import React from "react";
import LoginLink from "./LoginLink";
interface Props {
  loginOverride: boolean;
}
const ContactUsForPricing = ({
  loginOverride
}: Props) => {
  return <p className="price enter-email" data-sentry-component="ContactUsForPricing" data-sentry-source-file="ContactUsForPricing.tsx">
      {loginOverride ? <>
          {"Contact us or "} <LoginLink>login</LoginLink>
          {" for pricing"}
        </> : "Contact us for pricing"}
    </p>;
};
export default ContactUsForPricing;